import type { AllRouteEndpoints } from "../routeTypes";

export const appsAppGroupIdUserImportsImportIdInitializeMapCacheKeys: AllRouteEndpoints[] = [
  "/apps/:app_group_id/user_imports/:import_id",
];
